import classNames from 'classnames';
import React, { type ReactElement } from 'react';

import animationStyles from '../../../../animations/grid-animations.module.scss';
import { useConfig } from '../../../../contexts/config-context';
import { type Grid as GridType, type InputElement } from '../../types';
import { Focusable } from '../form/focusable';

import { getGridStyle } from './grid-options';
import styles from './grid.module.scss';

export const Grid = ({
  items,
  layout,
  isRTL,
}: {
  items: InputElement[];
  layout: GridType;
  isRTL?: boolean;
}) => {
  const { isMobile, enableAnimations } = useConfig();
  const reactElementsByRow = getReactElementsByRow(items);

  return (
    <div className={styles.container} dir={isRTL ? 'rtl' : ''}>
      {reactElementsByRow.map((rowData, index) => {
        const fieldId = rowData.firstFieldId;
        const key = (isMobile && fieldId) || index;

        return (
          <Focusable key={fieldId} fieldId={fieldId}>
            <div
              key={key}
              style={getGridStyle({ layout })}
              className={classNames(styles.grid, styles.column, {
                [animationStyles.animations]: enableAnimations,
              })}
            >
              {rowData.elements}
            </div>
          </Focusable>
        );
      })}
    </div>
  );
};

type RowData = {
  elements: ReactElement[];
  firstFieldId: string;
};

function getReactElementsByRow(items: InputElement[]): RowData[] {
  const reactElementsByRow = items.reduce<RowData[]>((result, item) => {
    const row = item.layout.row;
    const element = React.cloneElement(item.component, { key: item.id });

    if (result[row]) {
      result[row].elements.push(element);
    } else {
      result[row] = {
        elements: [element],
        firstFieldId: item.id,
      };
    }
    return result;
  }, []);

  return reactElementsByRow;
}
